import { GQL } from "@binale-tech/shared";

import type { AgentDetailItem, AgentStep, ReportLine } from "../runner/types";

export const bankImportStep: AgentStep = {
    id: "bankImport",
    product: [GQL.IProductKey.Banks],
    async run(ctx, io) {
        const banks = ctx.banks().filter((bank) => bank.finapiBankConnectionId);
        if (banks.length === 0) return { status: "nothing" };

        const summary: ReportLine[] = [];
        const details: AgentDetailItem[] = [];
        let skipped = 0;
        for (const bank of banks) {
            if (io.isCancelled()) break;
            io.post({ kind: "text", textId: "app.agent.bankImport.start", values: { bank: bank.bankName } });
            let count: number | null = null;
            const before = new Set(ctx.bankTransactions().map((tx) => String(tx.id)));
            const result = await io.panel({
                type: "bankImport",
                bankId: String(bank.id),
                onImported: (imported) => {
                    count = imported;
                },
            });
            if (result === "done") {
                const imported = ctx
                    .bankTransactions()
                    .map((tx) => String(tx.id))
                    .filter((id) => !before.has(id))
                    .map((id): AgentDetailItem => ({
                        group: "done",
                        ref: { kind: "bankTransaction", id },
                        outcome: { textId: "app.agent.details.bankImport.imported" },
                    }));
                details.push(...imported);
                const counted = count !== null;
                const values = counted ? { bank: bank.bankName, count } : { bank: bank.bankName };
                io.post({
                    kind: "done",
                    textId: counted ? "app.agent.bankImport.done" : "app.agent.bankImport.doneNoCount",
                    values,
                    details: imported,
                });
                summary.push({
                    textId: counted ? "app.agent.report.bankImported" : "app.agent.report.bankImportedNoCount",
                    values,
                });
            } else if (!io.isCancelled()) {
                skipped += 1;
                io.post({ kind: "skipped", textId: "app.agent.bankImport.skipped", values: { bank: bank.bankName } });
            }
        }

        const open: ReportLine[] =
            skipped > 0 ? [{ textId: "app.agent.report.bankSkipped", values: { count: skipped } }] : [];
        return { status: summary.length > 0 ? "done" : "nothing", summary, open, details };
    },
};
